import React, { useState } from "react";
import { Avatar, Button, Link } from "@alquiler-argentina/aa-componentes";
import { Box, Container, Typography, Dialog } from "@mui/material";
import styles from "./style";
import { useTheme } from "@mui/material";
import Footer from "../Footer";
import isMobile from 'ismobilejs';
import ModalCloseIcon from '../ModalCloseIcon';

const SocialLogin = ({ modalOpen, email, picture, name, identity, onCloseLoginModal, setViewSocialLogin }) => {
  const theme = useTheme();
  const classes = styles(theme);

  const isApp = window.location.href.includes("app");

  const signInFacebook = () => {
    const urlLoginFacebook = `${process.env.MIX_DOMAIN_COGNITO}/oauth2/authorize?identity_provider=Facebook&redirect_uri=${process.env.MIX_DOMINIO_WEB}/success-register&response_type=token&client_id=${process.env.MIX_CLIENT_ID_COGNITO}&skip_api_login=1&api_key=348110967079868&kid_directed_site=0&scope=email+openid+profile+aws.cognito.signin.user.admin&app_id=348110967079868&signed_next=1&display=page&locale=es_LA`
    if(modalOpen){
        window.open(urlLoginFacebook,  '_blank', 'location=yes , height=570 ,width=520, scrollbars=yes, status=yes'); 
    } else {
        window.open(urlLoginFacebook, '_self')
    }
  };

  const signInGoogle = () => {
    const urlLoginGoogle = `${process.env.MIX_DOMAIN_COGNITO}/oauth2/authorize?identity_provider=Google&redirect_uri=${!isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP}/success-register&response_type=token&client_id=${process.env.MIX_CLIENT_ID_COGNITO}&scope=email+openid+profile+aws.cognito.signin.user.admin`
    if(modalOpen){
        window.open(urlLoginGoogle,  '_blank', 'location=yes , height=570 ,width=520, scrollbars=yes, status=yes'); 
    } else {
        window.open(urlLoginGoogle, '_self')
    }
  };

  const socialLoginContainer =
    <Container css={classes.container}>
      {modalOpen && <ModalCloseIcon onClick={onCloseLoginModal} />}
      <Box css={classes.content}>
        <Box css={classes.userInfo}>
          <Avatar variant="circular" css={classes.avatar} src={picture} />
          <Box css={classes.infoWrapper}>
            <Typography css={classes.title}>Hola de nuevo, {name}</Typography>
            <Typography css={classes.email}>{email}</Typography>
          </Box>
        </Box>
        <Box>
          {/* identity 2 = Google */}
          {identity == 2 && (
            <Button
              css={classes.button}
              fullWidth
              variant="outlined"
              color="inherit"
              startIcon={<img src="/imagenes/googleIconColor.png" />}
              onClick={signInGoogle}
            >
              Ingresar con Google
            </Button>
          )}
          {/* identity 3 = Facebook */}
          {identity == 3 && !isApp && (
            <Button
              css={classes.button}
              fullWidth
              variant="outlined"
              color="inherit"
              startIcon={<img src="/imagenes/facebookIconColor.png" />}
              onClick={signInFacebook}
            >
              Ingresar con Facebook
            </Button>
          )}
          <Typography>
            ¿No sos vos? <Link underline="always" css={classes.accountLink} color={"#3E3E3E"} onClick={() => setViewSocialLogin(false)}>Usar otra cuenta.</Link>
          </Typography>
        </Box>
      </Box>
      <Footer />
    </Container>

  return (
    modalOpen ? (<Dialog css={isMobile.any ? classes.modal : ''} open={modalOpen}>{socialLoginContainer}</Dialog>) : socialLoginContainer
  );
};

export default SocialLogin;
